module.exports = __webpack_public_path__ + "static/img/announcement.94f26dbb.svg";